import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadStore } from '../../../redux/modules/store';
import AmexIcon from './icone_pagamenti/Amex';
import BonificoIcon from './icone_pagamenti/Bonifico';
import ContrassegnoIcon from './icone_pagamenti/Contrassegno';
import MastercardIcon from './icone_pagamenti/Mastercard';
import PaypalIcon from './icone_pagamenti/Paypal';
import VisaElectronIcon from './icone_pagamenti/VisaElectron';
import VisaIcon from './icone_pagamenti/Visa';
import lightOrDark from '../SlickArrow/colorArrowFunction';
import SatispayIcon from './icone_pagamenti/Satispay';

class MetodiPagamento extends Component {
  componentDidMount() {
    this.props.loadStore();
  }

  render() {
    const isBackgroundLightOrDark = lightOrDark(this.props.background);
    const iconColor = isBackgroundLightOrDark === 'light' ? '#000' : '#fff';

    let paymentTypes = [
      {
        id: 0,
        name: 'Amex',
        icon: <AmexIcon color={iconColor} style={{ width: 40, height: 24 }} />,
        on: this.props.hasAmex,
      },
      {
        id: 1,
        name: 'Bonifico Bancario',
        icon: (
          <BonificoIcon color={iconColor} style={{ width: 40, height: 24 }} />
        ),
        on: this.props.hasBank,
      },
      {
        id: 2,
        name: 'Contrassegno',
        icon: (
          <ContrassegnoIcon
            color={iconColor}
            style={{ width: 40, height: 24 }}
          />
        ),
        on: this.props.hasDelivery,
      },
      {
        id: 3,
        name: 'Mastercard',
        icon: (
          <MastercardIcon color={iconColor} style={{ width: 40, height: 24 }} />
        ),
        on: this.props.hasMastercard,
      },
      {
        id: 4,
        name: 'Paypal',
        icon: (
          <PaypalIcon color={iconColor} style={{ width: 48, height: 24 }} />
        ),
        on: this.props.hasPaypal,
      },
      {
        id: 5,
        name: 'Visa Electron',
        icon: (
          <VisaElectronIcon
            color={iconColor}
            style={{ width: 40, height: 24 }}
          />
        ),
        on: this.props.hasElectron,
      },
      {
        id: 6,
        name: 'Visa',
        icon: <VisaIcon color={iconColor} style={{ width: 40, height: 24 }} />,
        on: this.props.hasVisa,
      },
      {
        id: 7,
        name: 'Satispay',
        icon: (
          <SatispayIcon color={iconColor} style={{ width: 60, height: 24 }} />
        ),
        on: this.props.hasSatispay,
      },
    ];

    const paymentTypeList = paymentTypes
      .filter(item => !!item.on)
      .map(item => item.icon);

    return (
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {paymentTypeList}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hasAmex: state.store.data.funzionalita.allowAmexLogo,
  hasBank: state.store.data.funzionalita.allowBankTransferLogo,
  hasDelivery: state.store.data.funzionalita.allowDeliveryLogo,
  hasMastercard: state.store.data.funzionalita.allowMastercardLogo,
  hasPaypal: state.store.data.funzionalita.allowPaypalLogo,
  hasElectron: state.store.data.funzionalita.allowVisaElectronLogo,
  hasVisa: state.store.data.funzionalita.allowVisaLogo,
  hasSatispay: state.store.data.features.hasSatispay,
});

// export default Spedizionieri;
export default connect(mapStateToProps, { loadStore })(MetodiPagamento);
